import { css, keyframes } from "@emotion/react";
import { Box } from "@mui/material";

const DEFAULT_COLOR = "#FFC700";
export const generateSparkle = () => {
  return {
    id: Math.round(Math.random() * 1000000),
    color: DEFAULT_COLOR,
    size: Math.random() * 5 + 10,
    style: {
      top: `${1 - Math.random() * 2}px`,
      right: `${1 - Math.random() * 2}px`,
      //   top: Math.random() * 100 + "%",
      //   left: Math.random() * 100 + "%",
    },
  };
};
const SparkleFX = ({ size, color, style }) => {
  const path =
    "M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z";
  return (
    <Box
      sx={{
        position: "absolute",
        animation: `${comeInOut} 1000ms forwards`,
        ...style,
      }}>
      <Box
        sx={{
          animation: `${spin} 1000ms linear`,
        }}>
        <svg width={size} height={size} viewBox="0 0 68 68" fill="none">
          <path d={path} fill={color} />
        </svg>
      </Box>
    </Box>
  );
};
const comeInOut = keyframes`
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
`;
export default SparkleFX;
